
import { Base } from '../base-component';

import './deals-list-item.component.scss';

export class DealsListItem extends Base {

	constructor(element: Element){
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/deals-list-item/deals-list-item.component.ts